import React from 'react';
import styled from 'styled-components';

import {
  TextLink,
  Type,
  TypeList,
  TypeListItem,
} from '@spotify-internal/encore-creator-web';
import {
  gray50,
  gray95,
  screenXsMax,
  spacer8,
  spacer24,
} from '@spotify-internal/encore-foundation';

import { useViewport, Viewport } from '../../../../../shared/lib/useViewport';
import { blogPostUrl, programPoliciesUrl } from '../../lib/constants';
import { HSpacer64 } from '../../../Elements';

const AsideContainer = styled.aside`
  padding: ${spacer24};
  max-width: 310px;
  background-color: ${gray95};
  height: fit-content;
  border-radius: ${spacer8};

  @media (max-width: ${screenXsMax}) {
    max-width: 100%;
    margin: 0 auto;
  }
`;

const AsideHeading = styled(Type).attrs({
  forwardedAs: 'h4',
  variant: Type.body2,
  color: gray50,
})`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${Type.bold};
  white-space: nowrap;
`;

const AsideItem = styled(TypeListItem)`
  color: ${gray50};
  font-size: 16px;
  line-height: 24px;
`;

const AsideItemSpan = styled(Type).attrs({ variant: Type.body2 })`
  font-size: 16px;
  line-height: 24px;
`;

const AsideLink = styled(TextLink)`
  text-decoration: underline;
`;

const AsideList = styled(TypeList)`
  padding: 0;
  list-style-position: outside;
  margin-left: 1em;
  li:last-child {
    padding-bottom: 0;
  }
`;

const AsideWrapper = styled.div`
  display: flex;
`;

export function FormInputAside() {
  const viewport = useViewport();
  const condensed = viewport === Viewport.XS;

  return (
    <AsideWrapper>
      {condensed ? null : <HSpacer64 />}

      <AsideContainer>
        <AsideHeading>How Artist Fundraising Pick works</AsideHeading>
        <AsideList>
          <AsideItem>
            <AsideItemSpan>
              Your fundraising link will live at the top of your artist profile.
              It won't replace your Artist Pick.
            </AsideItemSpan>
          </AsideItem>
          <AsideItem>
            <AsideItemSpan>
              Spotify won't receive any money or commission through this
              feature.
            </AsideItemSpan>
          </AsideItem>
          <AsideItem>
            <AsideItemSpan>
              Make sure your link complies with{' '}
              <AsideLink href={programPoliciesUrl} target="policies">
                our program policies
              </AsideLink>
              .
            </AsideItemSpan>
          </AsideItem>
          <AsideItem>
            <AsideItemSpan>
              For more information about this initiative, please see{' '}
              <AsideLink href={blogPostUrl} target="blog_post">
                our blog post
              </AsideLink>
              .
            </AsideItemSpan>
          </AsideItem>
        </AsideList>
      </AsideContainer>
    </AsideWrapper>
  );
}
